// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"06f33a76","602":"62ddf22e","831":"3fa4d328","947":"739ec93d"}[chunkId] + ".chunk.css";
};